module.exports = __webpack_public_path__ + "img/slia_04.2d32e77e.png";